export default class GeometryModifier {
  getModifiedGeometry(sourceGeometry, params = null, matrix = null, resultGeometry = null) {
    if (resultGeometry) {
      return resultGeometry;
    }

    return sourceGeometry;
  }
}
